import { render, staticRenderFns } from "./freevideo.vue?vue&type=template&id=65a4abe6&scoped=true&"
import script from "./freevideo.vue?vue&type=script&lang=js&"
export * from "./freevideo.vue?vue&type=script&lang=js&"
import style0 from "./freevideo.vue?vue&type=style&index=0&id=65a4abe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4abe6",
  null
  
)

export default component.exports